import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { BuildingDocument } from '../../model/building-document';

import { ConnectedDocumentService } from './connected-document-base.service';

@Injectable()
export class BuildingDocumentService extends ConnectedDocumentService<BuildingDocument> {
  constructor(client: HttpClient, messageService: MessageService, progressBar: ProgressBarService, @Inject(APP_CONFIG) config: IAppConfig) {
    super(client, messageService, progressBar, 'building-documents', config);
  }

  createModel(): BuildingDocument {
    return new BuildingDocument();
  }
}
